import React from 'react';
import useResponsive, { QUERIES } from '@dealroadshow/uikit-hooks/useResponsive';
import styles from './actions.module.scss';
import ActionItem from './ActionItem';
import Dropdown from '@dealroadshow/uikit-menu/Dropdown';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';
import IDataroomAction from './IDataroomAction';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import IconKebabMenu from '@dealroadshow/uikit-icon/IconKebabMenu';

interface IProps {
  actionsConfig: Array<IDataroomAction>,
  mobileClassName: string,
  desktopClassName: string,
  twoFactorSpanClassname: string,
  cellProps: {
    row: IDataroomListItem,
  },
}

function Actions(
  {
    actionsConfig,
    mobileClassName,
    desktopClassName,
    twoFactorSpanClassname,
    cellProps,
  }: IProps,
) {
  const isMobile = useResponsive(QUERIES.MOBILE_PORTRAIT);

  const { tenant } = useDataroomTenantContext();

  const renderAction = (action: IDataroomAction, index: number) => (
    <ActionItem
      tenant={ tenant }
      key={ index }
      isMobile={ isMobile }
      disabled={ action.disabled }
      icon={ action.icon! }
      mobileTitle={ action.mobileTitle }
      tooltipContent={ action.tooltipContent! }
      path={ action.path }
      onClick={ action.onClick }
      route={ action.route }
      dataroom={ cellProps.row }
      twoFactorSpanClassname={ twoFactorSpanClassname }
      variant={ action.variant }
      buttonTitle={ action.buttonTitle }
      dataTest={ action.dataTest }
      disabledButtonTooltip={ action.disabledButtonTooltip }
    />
  );

  return (
    isMobile ? (
      <Dropdown
        className={ styles.mobileAdditionalOptionsTrigger }
        contentClassName={ styles.mobileDropdownContent }
        trigger={ <IconKebabMenu /> }
        data-test={ `${ tenant }DropdownActions` }
        isFlipEnabled={ false }
      >
        <div className={ mobileClassName }>
          <span>
            { actionsConfig.map(renderAction) }
          </span>
        </div>
      </Dropdown>
    ) : (
      <div className={ desktopClassName }>
        <span>
          { actionsConfig.map(renderAction) }
        </span>
      </div>
    ));
}

export default Actions;
